export default function GenericCardSkeleton() {
  return (
    <div className="w-full">
      <div className="rounded-2xl border overflow-hidden shadow-sm bg-gray-100 animate-pulse" style={{ minHeight: '200px' }}>
        {/* Card Header Skeleton */}
        <div className="relative p-4 flex justify-between items-center min-h-[120px]">
          <div className="flex items-center gap-4 flex-1">
            <div className="w-12 h-12 bg-gray-300 rounded-full"></div>
            <div className="flex flex-col gap-2">
              <div className="h-4 bg-gray-300 rounded w-16"></div>
              <div className="h-6 bg-gray-300 rounded w-20"></div>
            </div>
          </div>
          <div className="h-16 w-px bg-gray-300"></div>
          <div className="flex items-center gap-4 flex-1 justify-end">
            <div className="flex flex-col gap-2">
              <div className="h-4 bg-gray-300 rounded w-16"></div>
              <div className="h-6 bg-gray-300 rounded w-20"></div>
            </div>
            <div className="w-12 h-12 bg-gray-300 rounded-full"></div>
          </div>
        </div>

        {/* Card Content Skeleton */}
        <div className="p-4 bg-white">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-5 h-5 bg-gray-300 rounded"></div>
            <div className="h-4 bg-gray-300 rounded w-32"></div>
          </div>
          <div className="h-4 bg-gray-300 rounded w-full"></div>
        </div>
      </div>
    </div>
  );
}
